import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/jsx-pascal-case */ /* eslint-disable max-len */ import { ArchitectureLR, ArchitectureTB, Banner, BenefitsIcon, BenefitsImageText, BenefitsTab, ButtonPopup, BuyNow, BuyProduct1, BuyProduct2, Contact, CustomerAnomaly, CustomerCircleDescription, CustomerCircles, CustomerDescription, CustomersTab, CustomerTab, DdosChildren, FAQ, FlexAppendHtmlAttr, FlexInternationalLogo, FreeWithBuyNow, FreeWithCard, FreeWithCredit, FreeWithCreditIteration, ImCodeComponent, LTextRImage, NewBanner, Partner, PlainText, ProductIntroduction, ProductResource, QuickStarts, ScenariosGrid, ScenariosImageText, SceneChange, SceneTabs, SceneTabsRelevance, TciButton, Whitepaper } from '@tencent/cms-design-component';
import logger from 'portal-common/helpers/logger';
import ProductsService from './components/ProductsService';
import { asyncReceiveCommodity, doComponentsBgColorEvent, formatFreeWithCreditIteration } from './handler';
import { useIsMobileState } from './hooks/useIsMobileState';
import { useDataFormatMethods } from './utils/DataFormatInstance';
import { checkAccountType } from './utils/partners-utils';
import { reportShow } from './utils/reportUtil';
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
export default function ComponentsRenderer(props) {
    var data = props.data, index1 = props.index;
    var componentId = data === null || data === void 0 ? void 0 : data.component_id;
    var componentObject = data === null || data === void 0 ? void 0 : data.component_object;
    var productsServiceData = (data || {
    }).productsServiceData;
    // 经过域名处理的dataFormat
    var dataFormat = useDataFormatMethods();
    try {
        var styleObj = [
            {
                background: '#FFF'
            },
            {
                backgroundImage: 'linear-gradient(180deg, #DAE5F2 0%, #FFFFFF 100%)'
            },
            {
                background: '#FFF'
            },
            {
                background: '#F5F7FA'
            }, 
        ];
        var ref = _slicedToArray(useIsMobileState(), 1), isMobile = ref[0];
        var styleItem = {
        };
        if (index1 !== undefined) {
            styleItem = styleObj[index1 % 4];
        }
        var properties = (componentObject ? JSON.parse(componentObject) : {
        }).properties; // 获取cms的具体配置信息
        if (Object.prototype.toString.call(properties) === '[object Object]') {
            // 解决audio中componentId为了唯一拼接了diff，这里还原为Customers
            if (componentId.indexOf('Customers') >= 0) {
                componentId = 'Customers';
            }
            switch(componentId){
                case 'Contact':
                    {
                        var ref1 = dataFormat.formatContact(properties), modTitle = ref1.modTitle, title = ref1.title, content = ref1.content, pcBackgroundImage = ref1.pcBackgroundImage, mbBackgroundImage = ref1.mbBackgroundImage, buttonConfig = ref1.buttonConfig, extendProps = ref1.extendProps;
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle || componentId
                        }, reportShow([
                            'show_contact',
                            index1,
                            modTitle
                        ]), {
                            children: /*#__PURE__*/ _jsx(Contact, {
                                title: title,
                                content: content,
                                pcBackgroundImage: pcBackgroundImage,
                                mbBackgroundImage: mbBackgroundImage,
                                buttonConfig: buttonConfig,
                                extendProps: extendProps
                            })
                        })));
                    }
                case 'Architecture':
                    {
                        var ref2 = dataFormat.formatArchitecture(properties), configuration = ref2.configuration, modTitle1 = ref2.modTitle, bgColor = ref2.bgColor;
                        var bgStyle = doComponentsBgColorEvent(styleItem, bgColor); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle1 || componentId
                        }, reportShow([
                            'show_architecture',
                            index1,
                            modTitle1
                        ]), {
                            children: /*#__PURE__*/ _jsx(ArchitectureTB, {
                                configuration: configuration,
                                flexTitle: modTitle1,
                                style: bgStyle
                            })
                        })));
                    }
                case 'Banner':
                    {
                        // console.log('banner-properties', properties);
                        var ref3 = dataFormat.formatBanner(properties), imageSrc = ref3.imageSrc, backgroundUrlLogo = ref3.backgroundUrlLogo, insights = ref3.insights, buttonList = ref3.buttonList, switchList = ref3.switchList;
                        // tabShow 和 tabList 属性用于Banner组件下的切换模块的显示和数据内容
                        return(/*#__PURE__*/ _jsx(Banner, {
                            backgroundUrl: imageSrc,
                            backgroundUrlLogo: backgroundUrlLogo,
                            insights: insights,
                            buttonList: buttonList,
                            tabShow: switchList.length > 0,
                            tabList: switchList
                        }));
                    }
                case 'Benefits':
                    {
                        var ref4 = dataFormat.formatBenefits(properties), modTitle2 = ref4.modTitle, configuration1 = ref4.configuration, bgColor1 = ref4.bgColor;
                        var bgStyle1 = doComponentsBgColorEvent(styleItem, bgColor1); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle2 || componentId
                        }, reportShow([
                            'show_benefits',
                            index1,
                            modTitle2
                        ]), {
                            children: /*#__PURE__*/ _jsx(BenefitsImageText, {
                                flexTitle: modTitle2,
                                configuration: configuration1,
                                style: bgStyle1
                            })
                        })));
                    }
                case 'BenefitsTab':
                    {
                        var ref5 = dataFormat.formatBenefitsTab(properties), modTitle3 = ref5.modTitle, configuration2 = ref5.configuration, bgColor2 = ref5.bgColor;
                        var bgStyle2 = doComponentsBgColorEvent(styleItem, bgColor2); // 处理组件背景色
                        var onTabClick = function(item, index) {
                            var tabTitle = item && item.tabTitle;
                            // 返回的index是字符串格式，从1开始，无需处理
                            if (window.recordBehavior) {
                                window.recordBehavior.reportEvent('click_benefits_tab', {
                                    ext1: index,
                                    ext2: tabTitle
                                });
                            }
                        };
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle3 || componentId
                        }, reportShow([
                            'show_benefitsTab',
                            index1,
                            modTitle3
                        ]), {
                            children: /*#__PURE__*/ _jsx(BenefitsTab, {
                                flexTitle: modTitle3,
                                configuration: configuration2,
                                onTabClick: onTabClick,
                                style: bgStyle2
                            })
                        })));
                    }
                case 'Button':
                    {
                        var ref6 = dataFormat.formatButton(properties), modTitle4 = ref6.modTitle, configuration3 = ref6.configuration, bgColor3 = ref6.bgColor;
                        var bgStyle3 = doComponentsBgColorEvent(styleItem, bgColor3); // 处理组件背景色
                        var btnShow = null;
                        switch(configuration3.clickType1){
                            case 'openUrl':
                                btnShow = /*#__PURE__*/ _jsx(TciButton, {
                                    flexTitle: modTitle4,
                                    txt: configuration3.txt,
                                    tintType: configuration3.btnTheme,
                                    colType: configuration3.colType,
                                    sizeType: configuration3.sizeType,
                                    alignType: configuration3.alignType,
                                    onCallback: configuration3.callback,
                                    style: bgColor3 ? bgStyle3 : {
                                    }
                                });
                                break;
                            case 'btn':
                                btnShow = /*#__PURE__*/ _jsx(ButtonPopup, {
                                    flexTitle: modTitle4,
                                    txt: configuration3.txt,
                                    tintType: configuration3.btnTheme,
                                    colType: configuration3.colType,
                                    sizeType: configuration3.sizeType,
                                    alignType: configuration3.alignType,
                                    configuration: configuration3.configuration,
                                    style: bgColor3 ? bgStyle3 : {
                                    }
                                });
                                break;
                            default:
                                btnShow = null;
                                break;
                        }
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle4 || componentId,
                            style: {
                                marginBottom: '60px'
                            }
                        }, reportShow([
                            'show_button',
                            index1,
                            modTitle4
                        ]), {
                            children: btnShow
                        })));
                    }
                case 'Quickstarts':
                    {
                        var ref7 = dataFormat.formatQuickstarts(properties), configuration4 = ref7.configuration, modTitle5 = ref7.modTitle, bgColor4 = ref7.bgColor;
                        var bgStyle4 = doComponentsBgColorEvent(styleItem, bgColor4); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle5 || componentId
                        }, reportShow([
                            'show_quickstarts',
                            index1,
                            modTitle5
                        ]), {
                            children: /*#__PURE__*/ _jsx(QuickStarts, {
                                configuration: configuration4,
                                flexTitle: modTitle5,
                                style: bgStyle4
                            })
                        })));
                    }
                case 'Customers':
                    {
                        // 自定义包含多种配置形式，所以引入了一个字段diff来请区分不同的类型
                        var diff = (componentObject ? JSON.parse(componentObject) : {
                        }).diff;
                        var ref8 = dataFormat.formatCustomers(properties, diff), modTitle6 = ref8.modTitle, configuration5 = ref8.configuration, bgColor5 = ref8.bgColor;
                        var bgStyle5 = doComponentsBgColorEvent(styleItem, bgColor5); // 处理组件背景色
                        if (diff === 'textUrl') {
                            return(/*#__PURE__*/ _jsx("div", _objectSpread({
                                id: modTitle6 || diff
                            }, reportShow([
                                'show_textUrl',
                                index1,
                                modTitle6
                            ]), {
                                children: /*#__PURE__*/ _jsx(PlainText, {
                                    configuration: configuration5,
                                    flexTitle: modTitle6,
                                    style: bgStyle5
                                })
                            })));
                        }
                        if (diff === 'areaCard') {
                            var mergeComponentStatus = dataFormat.formatCustomers(properties, diff).mergeComponentStatus;
                            var onCallback = props.onCallback;
                            return(/*#__PURE__*/ _jsx("div", _objectSpread({
                                id: modTitle6 || diff
                            }, reportShow([
                                'show_areaCard',
                                index1,
                                modTitle6
                            ]), {
                                children: /*#__PURE__*/ _jsx(ScenariosImageText, {
                                    configuration: configuration5,
                                    mergeComponentStatus: mergeComponentStatus,
                                    flexTitle: modTitle6,
                                    style: bgStyle5,
                                    onTabClick: function(tabIndex, bindingNum) {
                                        onCallback && onCallback(tabIndex, bindingNum);
                                    }
                                })
                            })));
                        }
                        if (diff === 'picText') {
                            return(/*#__PURE__*/ _jsx("div", _objectSpread({
                                id: modTitle6 || diff
                            }, reportShow([
                                'show_picText',
                                index1,
                                modTitle6
                            ]), {
                                children: /*#__PURE__*/ _jsx(CustomerDescription, {
                                    configuration: configuration5,
                                    flexTitle: modTitle6,
                                    style: bgStyle5
                                })
                            })));
                        }
                        if (diff === 'logoText') {
                            return(/*#__PURE__*/ _jsx("div", _objectSpread({
                                id: modTitle6 || diff
                            }, reportShow([
                                'show_logoText',
                                index1,
                                modTitle6
                            ]), {
                                children: /*#__PURE__*/ _jsx(CustomerAnomaly, {
                                    configuration: configuration5,
                                    flexTitle: modTitle6,
                                    style: bgStyle5
                                })
                            })));
                        }
                        if (diff === 'circleLogoText') {
                            var description = dataFormat.formatCustomers(properties, diff).description;
                            return(/*#__PURE__*/ _jsx("div", _objectSpread({
                                id: modTitle6 || diff
                            }, reportShow([
                                'show_circleLogoText',
                                index1,
                                modTitle6
                            ]), {
                                children: /*#__PURE__*/ _jsx(CustomerCircles, {
                                    configuration: configuration5,
                                    flexTitle: modTitle6,
                                    description: description,
                                    style: bgStyle5
                                })
                            })));
                        }
                        if (diff === 'iconText') {
                            return(/*#__PURE__*/ _jsx("div", _objectSpread({
                                id: modTitle6 || diff
                            }, reportShow([
                                'show_iconText',
                                index1,
                                modTitle6
                            ]), {
                                children: /*#__PURE__*/ _jsx(BenefitsIcon, {
                                    configuration: configuration5,
                                    flexTitle: modTitle6,
                                    style: bgStyle5
                                })
                            })));
                        }
                        if (diff === 'html') {
                            return(/*#__PURE__*/ _jsx("div", _objectSpread({
                                id: modTitle6 || diff
                            }, reportShow([
                                'show_html',
                                index1,
                                modTitle6
                            ]), {
                                children: /*#__PURE__*/ _jsx(FlexAppendHtmlAttr, {
                                    configuration: configuration5
                                })
                            })));
                        }
                        return null;
                    }
                case 'MultipleScenarios':
                    {
                        var ref9 = dataFormat.formatMultipleScenarios(properties), configuration6 = ref9.configuration, modTitle7 = ref9.modTitle, bgColor6 = ref9.bgColor;
                        var bgStyle6 = doComponentsBgColorEvent(styleItem, bgColor6); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle7 || componentId
                        }, reportShow([
                            'show_multipleScenarios',
                            index1,
                            modTitle7
                        ]), {
                            children: /*#__PURE__*/ _jsx(LTextRImage, {
                                configuration: configuration6,
                                flexTitle: modTitle7,
                                style: bgStyle6
                            })
                        })));
                    }
                case 'RelatedProducts':
                    {
                        var ref10 = dataFormat.formatRelatedProducts(properties), modTitle8 = ref10.modTitle, configuration7 = ref10.configuration, bgColor7 = ref10.bgColor;
                        var bgStyle7 = doComponentsBgColorEvent(styleItem, bgColor7); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle8 || componentId
                        }, reportShow([
                            'show_relatedProducts',
                            index1,
                            modTitle8
                        ]), {
                            children: /*#__PURE__*/ _jsx(CustomerCircleDescription, {
                                configuration: configuration7,
                                flexTitle: modTitle8,
                                style: bgStyle7
                            })
                        })));
                    }
                case 'Scenarios':
                    {
                        var ref11 = dataFormat.formatScenarios(properties), configuration8 = ref11.configuration, modTitle9 = ref11.modTitle, bgColor8 = ref11.bgColor;
                        var bgStyle8 = doComponentsBgColorEvent(styleItem, bgColor8); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle9 || componentId
                        }, reportShow([
                            'show_scenarios',
                            index1,
                            modTitle9
                        ]), {
                            children: /*#__PURE__*/ _jsx(ArchitectureLR, {
                                configuration: configuration8,
                                flexTitle: modTitle9,
                                style: bgStyle8
                            })
                        })));
                    }
                case 'ScenariosCard':
                    {
                        var ref12 = dataFormat.formatScenariosCard(properties), modTitle10 = ref12.modTitle, configuration9 = ref12.configuration, bgColor9 = ref12.bgColor;
                        var bgStyle9 = doComponentsBgColorEvent(styleItem, bgColor9); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle10 || componentId
                        }, reportShow([
                            'show_scenariosCard',
                            index1,
                            modTitle10
                        ]), {
                            children: /*#__PURE__*/ _jsx(ScenariosGrid, {
                                configuration: configuration9,
                                flexTitle: modTitle10,
                                style: bgStyle9
                            })
                        })));
                    }
                case 'StoriesScenarios':
                    {
                        var ref13 = dataFormat.formatStoriesScenarios(properties), configuration10 = ref13.configuration, modTitle11 = ref13.modTitle, bgColor10 = ref13.bgColor;
                        var bgStyle10 = doComponentsBgColorEvent(styleItem, bgColor10); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle11 || componentId
                        }, reportShow([
                            'show_storiesScenarios',
                            index1,
                            modTitle11
                        ]), {
                            children: /*#__PURE__*/ _jsx(CustomerTab, {
                                configuration: configuration10,
                                flexTitle: modTitle11,
                                style: bgStyle10
                            })
                        })));
                    }
                case 'SceneChange':
                    {
                        var ref14 = dataFormat.formatSceneChange(properties), modTitle12 = ref14.modTitle, configuration11 = ref14.configuration, bgColor11 = ref14.bgColor;
                        var bgStyle11 = doComponentsBgColorEvent(styleItem, bgColor11); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle12 || componentId
                        }, reportShow([
                            'show_sceneChange',
                            index1,
                            modTitle12
                        ]), {
                            children: /*#__PURE__*/ _jsx(SceneChange, {
                                configuration: configuration11,
                                flexTitle: modTitle12,
                                style: bgStyle11
                            })
                        })));
                    }
                case 'ProductIntroduction':
                    {
                        var ref15 = dataFormat.formatProductIntroduction(properties), modTitle13 = ref15.modTitle, configuration12 = ref15.configuration, bgColor12 = ref15.bgColor;
                        var bgStyle12 = doComponentsBgColorEvent(styleItem, bgColor12); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle13 || componentId
                        }, reportShow([
                            'show_productIntroduction',
                            index1,
                            modTitle13
                        ]), {
                            children: /*#__PURE__*/ _jsx(ProductIntroduction, {
                                configuration: configuration12,
                                flexTitle: modTitle13,
                                style: bgStyle12
                            })
                        })));
                    }
                case 'SceneTabs':
                    {
                        var ref16 = dataFormat.formatSceneTabs(properties), configuration13 = ref16.configuration, modTitle14 = ref16.modTitle, bgColor13 = ref16.bgColor, _desc = ref16.desc, desc = _desc === void 0 ? '' : _desc;
                        var bgStyle13 = doComponentsBgColorEvent(styleItem, bgColor13); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle14 || componentId
                        }, reportShow([
                            'show_sceneTabs',
                            index1,
                            modTitle14
                        ]), {
                            children: /*#__PURE__*/ _jsx(SceneTabs, {
                                configuration: configuration13,
                                flexTitle: modTitle14,
                                desc: desc,
                                style: bgStyle13
                            })
                        })));
                    }
                case 'BuyNowNew':
                    {
                        var ref17 = dataFormat.formatBuyNowNew(properties), modTitle15 = ref17.modTitle, configuration14 = ref17.configuration, bgColor14 = ref17.bgColor;
                        var bgStyle14 = doComponentsBgColorEvent(styleItem, bgColor14); // 处理组件背景色
                        // console.log(configuration, 'configuration---BuyNow');
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle15 || componentId
                        }, reportShow([
                            'show_buyNowNew',
                            index1,
                            modTitle15
                        ]), {
                            children: /*#__PURE__*/ _jsx(BuyNow, {
                                flexTitle: modTitle15,
                                configuration: configuration14,
                                style: bgStyle14,
                                onCallback: function(item) {
                                    asyncReceiveCommodity(item);
                                }
                            })
                        })));
                    }
                case 'BuyNow':
                    {
                        var ref18 = dataFormat.formatBuyNowOld(properties), modTitle16 = ref18.modTitle, configuration15 = ref18.configuration, bgColor15 = ref18.bgColor;
                        var bgStyle15 = doComponentsBgColorEvent(styleItem, bgColor15); // 处理组件背景色
                        // console.log(configuration, 'configuration---BuyNow');
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle16 || componentId
                        }, reportShow([
                            'show_buyNow',
                            index1,
                            modTitle16
                        ]), {
                            children: /*#__PURE__*/ _jsx(BuyNow, {
                                flexTitle: modTitle16,
                                configuration: configuration15,
                                style: bgStyle15,
                                onCallback: function(item) {
                                    window.location.href = item.but_href;
                                // asyncAccountInfoCoupon(configuration);
                                }
                            })
                        })));
                    }
                case 'FreeWithCardNew':
                    {
                        var ref19 = dataFormat.formatFreeWithCardNew(properties), modTitle17 = ref19.modTitle, configuration16 = ref19.configuration, bgColor16 = ref19.bgColor;
                        var bgStyle16 = doComponentsBgColorEvent(styleItem, bgColor16); // 处理组件背景色
                        // console.log(configuration, 'configuration-FreeWithCard');
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle17 || componentId
                        }, reportShow([
                            'show_freeWithCardNew',
                            index1,
                            modTitle17
                        ]), {
                            children: /*#__PURE__*/ _jsx(FreeWithCard, {
                                flexTitle: modTitle17,
                                configuration: configuration16,
                                style: bgStyle16,
                                onCallback: function() {
                                    // console.log(configuration, 'configuration-FreeWithCard');
                                    asyncReceiveCommodity(configuration16[configuration16.length - 1]);
                                // asyncAccountInfoCoupon(configuration);
                                // verfyCouponFn();
                                }
                            })
                        })));
                    }
                case 'FreeWithCard':
                    {
                        var ref20 = dataFormat.formatFreeWithCardOld(properties), modTitle18 = ref20.modTitle, configuration17 = ref20.configuration, bgColor17 = ref20.bgColor;
                        var bgStyle17 = doComponentsBgColorEvent(styleItem, bgColor17); // 处理组件背景色
                        // console.log(configuration, 'configuration-FreeWithCard');
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle18 || componentId
                        }, reportShow([
                            'show_freeWithCard',
                            index1,
                            modTitle18
                        ]), {
                            children: /*#__PURE__*/ _jsx(FreeWithCard, {
                                flexTitle: modTitle18,
                                configuration: configuration17,
                                style: bgStyle17,
                                onCallback: function() {
                                // console.log(configuration, 'configuration-FreeWithCard');
                                // asyncAccountInfoCoupon(configuration);
                                }
                            })
                        })));
                    }
                case 'FreeWithBuyNowNew':
                    {
                        styleItem.marginTop = '-24px';
                        var ref21 = dataFormat.formatFreeWithBuyNowNew(properties), modTitle19 = ref21.modTitle, configuration18 = ref21.configuration;
                        // console.log(configuration, 'configuration-FreeWithBuyNow');
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle19 || componentId
                        }, reportShow([
                            'show_freeWithBuyNowNew',
                            index1,
                            modTitle19
                        ]), {
                            children: /*#__PURE__*/ _jsx(FreeWithBuyNow, {
                                flexTitle: modTitle19,
                                configuration: configuration18,
                                style: styleItem,
                                onCallback: function(item) {
                                    asyncReceiveCommodity(item);
                                }
                            })
                        })));
                    }
                case 'FreeWithBuyNow':
                    {
                        styleItem.marginTop = '-24px';
                        var ref22 = dataFormat.formatFreeWithBuyNowOld(properties), modTitle20 = ref22.modTitle, configuration19 = ref22.configuration, bgColor18 = ref22.bgColor;
                        var bgStyle18 = doComponentsBgColorEvent(styleItem, bgColor18); // 处理组件背景色
                        // console.log(configuration, 'configuration-FreeWithBuyNow');
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle20 || componentId
                        }, reportShow([
                            'show_freeWithBuyNow',
                            index1,
                            modTitle20
                        ]), {
                            children: /*#__PURE__*/ _jsx(FreeWithBuyNow, {
                                flexTitle: modTitle20,
                                configuration: configuration19,
                                style: bgStyle18,
                                onCallback: function(item) {
                                    window.location.href = item.but_href;
                                // asyncReceiveCommodity(item);
                                }
                            })
                        })));
                    }
                case 'FreeWithCredit':
                    {
                        var ref23 = dataFormat.formatFreeWithCredit(properties), modTitle21 = ref23.modTitle, configuration20 = ref23.configuration, bgColor19 = ref23.bgColor;
                        var bgStyle19 = doComponentsBgColorEvent(styleItem, bgColor19); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle21 || componentId
                        }, reportShow([
                            'show_freeWithCredit',
                            index1,
                            modTitle21
                        ]), {
                            children: /*#__PURE__*/ _jsx(FreeWithCredit, {
                                flexTitle: modTitle21,
                                configuration: configuration20,
                                style: bgStyle19,
                                onClick: function(item) {
                                    asyncReceiveCommodity(item);
                                }
                            })
                        })));
                    }
                case 'ProductCards':
                    {
                        dataFormat.formatProductCards(properties);
                        var ref24 = dataFormat.formatProductCards(properties), modTitle22 = ref24.modTitle, configuration21 = ref24.configuration;
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle22
                        }, reportShow([
                            'show_productCards',
                            index1,
                            modTitle22
                        ]), {
                            children: /*#__PURE__*/ _jsx(DdosChildren, {
                                flexTitle: modTitle22,
                                configuration: configuration21
                            })
                        })));
                    }
                case 'SceneTabsRelevance':
                    {
                        var ref25 = dataFormat.formatSceneTabsRelevance(properties), modTitle23 = ref25.modTitle, configuration22 = ref25.configuration, bgColor20 = ref25.bgColor;
                        var bgStyle20 = doComponentsBgColorEvent(styleItem, bgColor20); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle23 || componentId
                        }, reportShow([
                            'show_sceneTabsRelevance',
                            index1,
                            modTitle23
                        ]), {
                            children: /*#__PURE__*/ _jsx(SceneTabsRelevance, {
                                flexTitle: modTitle23,
                                configuration: configuration22,
                                style: bgStyle20
                            })
                        })));
                    }
                case 'BuyProduct1':
                    {
                        var ref26 = dataFormat.formatBuyProduct(properties), modTitle24 = ref26.modTitle, configuration23 = ref26.configuration, bgColor21 = ref26.bgColor, backgroundImage = ref26.backgroundImage;
                        var bgStyle21 = doComponentsBgColorEvent(styleItem, bgColor21); // 处理组件背景色
                        if (backgroundImage && !isMobile) {
                            bgStyle21.backgroundImage = "url(".concat(backgroundImage, ")");
                            bgStyle21.backgroundSize = 'cover';
                        }
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle24 || componentId
                        }, reportShow([
                            'show_buyProduct1',
                            index1,
                            modTitle24
                        ]), {
                            children: /*#__PURE__*/ _jsx(BuyProduct1, {
                                flexTitle: modTitle24,
                                configuration: configuration23,
                                style: bgStyle21,
                                onCallback: function(item) {
                                    window.location.href = item.but_href;
                                }
                            })
                        })));
                    }
                case 'BuyProduct2':
                    {
                        var ref27 = dataFormat.formatBuyProduct(properties), modTitle25 = ref27.modTitle, configuration24 = ref27.configuration, bgColor22 = ref27.bgColor, backgroundImage1 = ref27.backgroundImage;
                        var bgStyle22 = {
                            backgroundColor: bgColor22
                        }; // 处理组件背景色
                        if (backgroundImage1 && !isMobile) {
                            bgStyle22.backgroundImage = "url(".concat(backgroundImage1, ")");
                            bgStyle22.backgroundSize = 'cover';
                        }
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle25 || componentId
                        }, reportShow([
                            'show_buyProduct2',
                            index1,
                            modTitle25
                        ]), {
                            children: /*#__PURE__*/ _jsx(BuyProduct2, {
                                flexTitle: modTitle25,
                                configuration: configuration24,
                                style: bgStyle22,
                                onCallback: function(item) {
                                    window.location.href = item.but_href;
                                }
                            })
                        })));
                    }
                case 'NewBanner':
                    {
                        var ref28 = dataFormat.formatNewBanner(properties), title1 = ref28.title, content1 = ref28.content, backgroundUrl = ref28.backgroundUrl, backgroundUrlLogo1 = ref28.backgroundUrlLogo, backgroundVideoUrl = ref28.backgroundVideoUrl, lightTheme = ref28.lightTheme, buttonList1 = ref28.buttonList, linkList = ref28.linkList, liveType = ref28.liveType;
                        return(/*#__PURE__*/ _jsx(NewBanner, _objectSpread({
                            title: title1,
                            content: content1,
                            backgroundUrl: backgroundUrl,
                            backgroundUrlLogo: backgroundUrlLogo1,
                            backgroundVideoUrl: backgroundVideoUrl,
                            lightTheme: lightTheme,
                            buttonList: buttonList1,
                            tabList: linkList,
                            liveType: liveType,
                            onCallback: function(item) {
                                if (window.location.href.indexOf('partner') === -1 || item.href.indexOf('partners') === -1) {
                                    window.location.href = item.href;
                                    return;
                                }
                                checkAccountType();
                            }
                        }, reportShow([
                            'show_newBanner',
                            0,
                            title1
                        ]))));
                    }
                case 'ProductsService':
                    {
                        var ref29 = dataFormat.formatProductsService(properties), title2 = ref29.title, color = ref29.color;
                        return(/*#__PURE__*/ _jsx(ProductsService, {
                            title: title2,
                            style: {
                                backgroundColor: color
                            },
                            list: productsServiceData,
                            index: index1
                        }));
                    }
                case 'FlexCustomersTab':
                    {
                        var ref30 = dataFormat.formatCustomersTab(properties), modTitle26 = ref30.modTitle, configuration25 = ref30.configuration, bgColor23 = ref30.bgColor;
                        var bgStyle23 = doComponentsBgColorEvent(styleItem, bgColor23); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle26 || componentId
                        }, reportShow([
                            'show_flexCustomersTab',
                            index1,
                            modTitle26
                        ]), {
                            children: /*#__PURE__*/ _jsx(CustomersTab, {
                                flexTitle: modTitle26,
                                configuration: configuration25,
                                style: bgStyle23
                            })
                        })));
                    }
                case 'ProductResource':
                    {
                        // 资源组件
                        var ref31 = dataFormat.formatProductResource(properties), modTitle27 = ref31.modTitle, desc1 = ref31.desc, cardData = ref31.cardData, videoData = ref31.videoData, txtData = ref31.txtData, bgColor24 = ref31.bgColor;
                        var bgStyle24 = doComponentsBgColorEvent(styleItem, bgColor24); // 处理组件背景色
                        var onCallback1 = props.onCallback;
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle27 || componentId
                        }, reportShow([
                            'show_productResource',
                            index1,
                            modTitle27
                        ]), {
                            children: /*#__PURE__*/ _jsx(ProductResource, {
                                flexTitle: modTitle27,
                                desc: desc1,
                                cardData: cardData,
                                videoData: videoData,
                                txtData: txtData,
                                style: bgStyle24,
                                onClick: function(tabIndex, bindingNum) {
                                    onCallback1 && onCallback1(tabIndex, bindingNum);
                                }
                            })
                        })));
                    }
                case 'Whitepaper':
                    {
                        // 白皮书组件
                        var ref32 = dataFormat.formatWhitepaper(properties), modTitle28 = ref32.modTitle, configuration26 = ref32.configuration, bgColor25 = ref32.bgColor;
                        var bgStyle25 = doComponentsBgColorEvent(styleItem, bgColor25); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle28 || componentId
                        }, reportShow([
                            'show_whitepaper',
                            index1,
                            modTitle28
                        ]), {
                            children: /*#__PURE__*/ _jsx(Whitepaper, {
                                flexTitle: modTitle28,
                                configuration: configuration26,
                                style: bgStyle25
                            })
                        })));
                    }
                case 'Faq':
                    {
                        // faq组件
                        var ref33 = dataFormat.formatFaq(properties), modTitle29 = ref33.modTitle, configuration27 = ref33.configuration, bgColor26 = ref33.bgColor;
                        var bgStyle26 = doComponentsBgColorEvent(styleItem, bgColor26); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle29 || componentId
                        }, reportShow([
                            'show_faq',
                            index1,
                            modTitle29
                        ]), {
                            children: /*#__PURE__*/ _jsx(FAQ, {
                                flexTitle: modTitle29,
                                configuration: configuration27,
                                style: bgStyle26
                            })
                        })));
                    }
                case 'FreeWithCreditIteration':
                    {
                        // 代金券（企业/个人）
                        var ref34 = formatFreeWithCreditIteration(properties), modTitle30 = ref34.modTitle, headConfig = ref34.headConfig, configuration28 = ref34.configuration, bgColor27 = ref34.bgColor;
                        var bgStyle27 = doComponentsBgColorEvent(styleItem, bgColor27); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle30 || componentId
                        }, reportShow([
                            'show_freeWithCreditIteration',
                            index1,
                            modTitle30
                        ]), {
                            children: /*#__PURE__*/ _jsx(FreeWithCreditIteration, {
                                flexTitle: modTitle30,
                                configuration: configuration28,
                                headConfig: headConfig,
                                style: bgStyle27
                            })
                        })));
                    }
                case 'Partner':
                    {
                        // 合作伙伴模块
                        var ref35 = dataFormat.formatParther(properties), modTitle31 = ref35.modTitle, description1 = ref35.description, titleList = ref35.titleList, bgColor28 = ref35.bgColor, contentList = ref35.contentList;
                        var bgStyle28 = doComponentsBgColorEvent(styleItem, bgColor28); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle31 || componentId
                        }, reportShow([
                            'show_partner',
                            index1,
                            modTitle31
                        ]), {
                            children: /*#__PURE__*/ _jsx(Partner, {
                                flexTitle: modTitle31,
                                description: description1,
                                titleList: titleList,
                                contentList: contentList,
                                style: bgStyle28
                            })
                        })));
                    }
                case 'Code':
                    {
                        // 代码显示模块
                        var ref36 = dataFormat.formatCode(properties), modTitle32 = ref36.modTitle, title3 = ref36.title, desc2 = ref36.desc, href = ref36.href, bgColor29 = ref36.bgColor, configuration29 = ref36.configuration;
                        var bgStyle29 = doComponentsBgColorEvent(styleItem, bgColor29); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle32 || componentId
                        }, reportShow([
                            'show_code',
                            index1,
                            modTitle32
                        ]), {
                            children: /*#__PURE__*/ _jsx(ImCodeComponent, {
                                title: modTitle32,
                                desc: desc2,
                                link: {
                                    txt: title3,
                                    href: href
                                },
                                configuration: configuration29,
                                style: bgStyle29
                            })
                        })));
                    }
                case 'FlexInternationalLogo':
                    {
                        // 代码显示模块
                        var ref37 = dataFormat.formatFlexInternationalLogo(properties), modTitle33 = ref37.modTitle, desc3 = ref37.desc, color1 = ref37.color, configuration30 = ref37.configuration;
                        var bgStyle30 = doComponentsBgColorEvent(styleItem, color1); // 处理组件背景色
                        return(/*#__PURE__*/ _jsx("div", _objectSpread({
                            id: modTitle33 || componentId
                        }, reportShow([
                            'show_flexInternationalLogo',
                            index1,
                            modTitle33
                        ]), {
                            children: /*#__PURE__*/ _jsx(FlexInternationalLogo, {
                                flexTitle: modTitle33,
                                desc: desc3,
                                configuration: configuration30,
                                style: bgStyle30
                            })
                        })));
                    }
            }
        }
    } catch (e) {
        logger.error('[Error] Jp2component', e);
        return null;
    }
};
